import { render, staticRenderFns } from "./TabScroll.vue?vue&type=template&id=70362933&"
import script from "./TabScroll.vue?vue&type=script&lang=js&"
export * from "./TabScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports